import { useRef, useState, useEffect } from 'react';

/* Leichtgewichtiges Unterschriften-Pad (rein gestalterisch, kein Identitätsnachweis) */
export const SignaturePad = ({ value, onChange }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(!value);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext('2d');
    ctx.lineWidth = 2.2; ctx.lineCap = 'round'; ctx.strokeStyle = '#2b2b28';
    if (value) { const img = new Image(); img.onload = () => ctx.drawImage(img, 0, 0); img.src = value; setEmpty(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (canvasRef.current.width / r.width), y: (e.clientY - r.top) * (canvasRef.current.height / r.height) };
  };
  const start = (e) => { drawing.current = true; const p = pos(e); const ctx = canvasRef.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(p.x, p.y); e.target.setPointerCapture?.(e.pointerId); };
  const move = (e) => { if (!drawing.current) return; const p = pos(e); const ctx = canvasRef.current.getContext('2d'); ctx.lineTo(p.x, p.y); ctx.stroke(); setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; if (!empty || true) onChange(canvasRef.current.toDataURL('image/png')); };
  const clear = () => { const c = canvasRef.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(null); };

  return (
    <div data-testid="signature-pad">
      <canvas
        ref={canvasRef} width={560} height={180}
        className="w-full max-w-md h-36 rounded-lg border border-[var(--border,#ddd)] bg-white/50 touch-none cursor-crosshair"
        style={{ touchAction: 'none' }}
        onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end}
        data-testid="signature-canvas"
      />
      <div className="mt-2 flex gap-4">
        <button type="button" onClick={clear} data-testid="signature-clear-btn"
          className="text-xs text-[var(--muted)] hover:text-[var(--text)] py-1 underline underline-offset-4 decoration-[var(--muted)]/40 transition-colors">
          Neu unterschreiben
        </button>
      </div>
    </div>
  );
};
